<template>
  <div class="auth-page container py-5">
    <div class="row justify-content-center">
      <div class="col-md-6 col-lg-5">
        <LoginForm :title="t('LoginTitle')" :subtitle="t('LoginFormSubtitle')" />

        <div class="register-hint">
          <p v-tx="'LoginNoAccount'">{{ t('LoginNoAccount') }}</p>
          <router-link v-if="canClinic" :to="{ name: 'register-clinic' }" v-tx="'LoginRegClinic'">{{ t('LoginRegClinic') }}</router-link>
          <span v-if="canClinic" class="dot">•</span>
          <router-link :to="{ name: 'register-nurse' }" v-tx="'LoginRegNurse'">{{ t('LoginRegNurse') }}</router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import LoginForm from "@/components/auth/LoginForm.vue";

const FALLBACK = {
  az: {
    LoginTitle: "Daxil ol",
    LoginFormSubtitle: "Hesabınızla daxil olun.",
    LoginNoAccount: "Hesabınız yoxdur?",
    LoginRegClinic: "Klinika kimi qeydiyyat",
    LoginRegNurse: "Tibb bacısı kimi qeydiyyat",
  },
  de: {
    LoginTitle: "Anmelden",
    LoginFormSubtitle: "Melden Sie sich mit Ihrem Konto an.",
    LoginNoAccount: "Noch kein Konto?",
    LoginRegClinic: "Als Klinik registrieren",
    LoginRegNurse: "Als Pflegekraft registrieren",
  },
  en: {
    LoginTitle: "Sign in",
    LoginFormSubtitle: "Sign in with your account.",
    LoginNoAccount: "Don't have an account?",
    LoginRegClinic: "Register as clinic",
    LoginRegNurse: "Register as nurse",
  },
  ru: {
    LoginTitle: "Войти",
    LoginFormSubtitle: "Войдите в свой аккаунт.",
    LoginNoAccount: "Нет аккаунта?",
    LoginRegClinic: "Регистрация клиники",
    LoginRegNurse: "Регистрация медсестры",
  },
  tr: {
    LoginTitle: "Giriş yap",
    LoginFormSubtitle: "Hesabınızla giriş yapın.",
    LoginNoAccount: "Hesabınız yok mu?",
    LoginRegClinic: "Klinik olarak kayıt",
    LoginRegNurse: "Hemşire olarak kayıt",
  },
};

export default {
  name: "LoginPage",
  components: { LoginForm },
  computed: {
    canClinic() {
      const lang = this.$store.state.lang;
      return this.$store.getters["featureSettings/canRegisterClinic"](lang);
    },
  },
  methods: {
    t(key) {
      const v = this.$store.state.statics?.[key];
      if (v && String(v).trim()) return v;
      const lang = this.$store.state.lang || "az";
      return (FALLBACK[lang] || FALLBACK.az)[key] || "";
    },
  },
};
</script>

<style lang="scss" scoped>
.auth-page { min-height: 60vh; }
.register-hint {
  margin-top: 1.25rem;
  text-align: center;
  font-size: 0.88rem;
  color: #64748b;
  p { margin-bottom: 0.4rem; }
  a { color: #2a5298; text-decoration: none; &:hover { text-decoration: underline; } }
  .dot { margin: 0 0.5rem; color: #cbd5e1; }
}
</style>
